import { Component, OnInit } from '@angular/core';
import { UserActionConfigService } from '../../../services/user-action-config/user-action-config.service';

@Component({
    selector: 'ref-ref-customers',
    templateUrl: './ref-customers.component.html',
    styleUrls: ['./ref-customers.component.scss'],
    standalone: false
})
export class RefCustomersComponent implements OnInit {
  constructor(public configService: UserActionConfigService) {}

  ngOnInit() {}
}
